module.exports = __webpack_public_path__ + "img/chevron-down.4f847d1c.svg";